import { Component } from 'react';
import Counter from './Counter';
import { calculatePricePerInterval } from './utils';

class AddOns extends Component {
    constructor(props) {
        super(props);

        this.onUpdateInput = this.onUpdateInput.bind(this);
    }

    onUpdateInput = (name, value) => {
        this.props.updateAddOns(name, value);
    };

    render() {
        const { billingInfo } = this.props;
        const { defaultAddOns } = this.props;

        const diffContentAnalysis =
            (this.props?.contentAnalysis || 0) - (defaultAddOns?.contentAnalysis || 0);
        const diffAdditionalSeats =
            (this.props.additionalSeats || 0) - (defaultAddOns?.additionalSeats || 0);

        const additionalSeatsPrice =
            calculatePricePerInterval(
                billingInfo.additional_seats?.prices,
                diffAdditionalSeats,
                this.props.interval,
            )?.price || 0;

        const contentAnalysisPrice =
            calculatePricePerInterval(
                billingInfo.content_analysis?.prices,
                diffContentAnalysis,
                this.props.interval,
            )?.price || 0;

        return (
            <>
                <div className="custom-registration-body-step">
                    <div className="custom-registration-body-step-header">
                        <span>2</span> Add-Ons
                    </div>
                    <div className="custom-registration-body-step-subheader">
                        Review what's included, what you have, and update your quantities.
                    </div>
                    <div className="custom-registration-body-step-body">
                        <div className="custom-registration-add-ons">
                            <div className="custom-registration-add-ons-item">
                                <div className="custom-registration-add-ons-item-header">
                                    <div className="custom-registration-add-ons-item-header-icon">
                                        <img src="/static/img/file-search-02.svg" alt="" />
                                    </div>
                                    Additional Discover Content Analysis
                                </div>
                                <div className="custom-registration-add-ons-item-body">
                                    <div className="custom-registration-add-ons-item-body-box">
                                        <div className="custom-registration-add-ons-item-body-box-header">
                                            Included in plan
                                        </div>
                                        <div className="custom-registration-add-ons-item-body-box-content">
                                            {window?.user_permissions?.content_analysis?.plan || 0}{' '}
                                            included
                                        </div>
                                    </div>
                                    <div className="custom-registration-add-ons-item-body-box">
                                        <div className="custom-registration-add-ons-item-body-box-header">
                                            Already purchased
                                        </div>
                                        <div className="custom-registration-add-ons-item-body-box-content blue">
                                            {this.props.defaultAddOns?.contentAnalysis || 0} active
                                        </div>
                                    </div>
                                    <div className="custom-registration-add-ons-item-body-box">
                                        <div className="custom-registration-add-ons-item-body-box-header">
                                            Update Quantity of Total Add-Ons
                                        </div>
                                        <div className="custom-registration-add-ons-item-body-box-content-last">
                                            <Counter
                                                value={this.props.contentAnalysis}
                                                onChange={(value) =>
                                                    this.onUpdateInput('contentAnalysis', value)
                                                }
                                                minValue={0}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {diffContentAnalysis !== 0 ? (
                                    <div
                                        className={`custom-registration-add-ons-item-message ${
                                            diffContentAnalysis <= 0 ? 'red-box' : ''
                                        }`}
                                    >
                                        <div className="custom-registration-round-icon-circle">
                                            <i className="icon-check-icon" />
                                        </div>{' '}
                                        <div>{diffContentAnalysis} item(s) added</div>
                                        <div>+${contentAnalysisPrice}/month</div>
                                    </div>
                                ) : (
                                    <div className="custom-registration-add-ons-item-footer">
                                        <div className="custom-registration-round-icon-circle">
                                            <i className="icon-check-icon" />
                                        </div>{' '}
                                        <span>No Change.</span> You will not be charged for this
                                        add-on.
                                    </div>
                                )}
                            </div>
                            <div className="custom-registration-add-ons-item">
                                <div className="custom-registration-add-ons-item-header">
                                    <div className="custom-registration-add-ons-item-header-icon">
                                        <img src="/static/img/sofa.svg" alt="" />
                                    </div>
                                    Additional Seats
                                </div>
                                <div className="custom-registration-add-ons-item-body">
                                    <div className="custom-registration-add-ons-item-body-box">
                                        <div className="custom-registration-add-ons-item-body-box-header">
                                            Included in plan
                                        </div>
                                        <div className="custom-registration-add-ons-item-body-box-content">
                                            {window?.user_permissions?.seats?.plan || 0} included
                                        </div>
                                    </div>
                                    <div className="custom-registration-add-ons-item-body-box">
                                        <div className="custom-registration-add-ons-item-body-box-header">
                                            Already purchased
                                        </div>
                                        <div className="custom-registration-add-ons-item-body-box-content blue">
                                            {this.props.defaultAddOns?.additionalSeats || 0} active
                                        </div>
                                    </div>
                                    <div className="custom-registration-add-ons-item-body-box">
                                        <div className="custom-registration-add-ons-item-body-box-header">
                                            Update Quantity of Total Add-Ons
                                        </div>
                                        <div className="custom-registration-add-ons-item-body-box-content-last">
                                            <Counter
                                                value={this.props.additionalSeats}
                                                onChange={(value) =>
                                                    this.onUpdateInput('additionalSeats', value)
                                                }
                                                minValue={0}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {diffAdditionalSeats !== 0 ? (
                                    <div
                                        className={`custom-registration-add-ons-item-message ${
                                            diffAdditionalSeats <= 0 ? 'red-box' : ''
                                        }`}
                                    >
                                        <div className="custom-registration-round-icon-circle">
                                            <i className="icon-check-icon" />
                                        </div>{' '}
                                        <div>{diffAdditionalSeats} seat(s) added</div>
                                        <div>+${additionalSeatsPrice}/month</div>
                                    </div>
                                ) : (
                                    <div className="custom-registration-add-ons-item-footer">
                                        <div className="custom-registration-round-icon-circle">
                                            <i className="icon-check-icon" />
                                        </div>{' '}
                                        <span>No Change.</span> You will not be charged for this
                                        add-on.
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default AddOns;
